import React from 'react';
import { Modal } from '@/components/ui/layout/Modal';
import { AlertTriangle } from 'lucide-react';
import { backgroundClip } from 'html2canvas/dist/types/css/property-descriptors/background-clip';
import { Button } from '../form/Button';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info' | 'secondary';
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger',
}) => {
  const variantStyles = {
    danger: {
      icon: 'text-red-500',
      button: 'bg-red-600 hover:bg-red-700',
      border: 'border-red-100',
    },
    warning: {
      icon: 'text-yellow-500',
      button: 'bg-yellow-600 hover:bg-yellow-700',
      border: 'border-yellow-100',
    },
    info: {
      icon: 'text-blue-500',
      button: 'bg-blue-600 hover:bg-blue-700',
      border: 'border-blue-100',
    },
    secondary: {
      icon: 'text-gray-500',
      button: 'bg-gray-600 hover:bg-blue-700',
      border: 'border-gray-100',
    }
  };

  const current = variantStyles[variant];

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='sm'>
      <div className={`p-6 border-l-4 ${current.border}`}>
        <div className='flex items-center gap-4 mb-4'>
          <div className={`p-2 rounded-full bg-gray-50 ${current.icon}`}>
            <AlertTriangle className='w-6 h-6' />
          </div>
          <h2 className='text-xl font-semibold'>{title}</h2>
        </div>
        <p className='mb-6 text-gray-600'>{message}</p>{' '}
        {/* Changed <b> to <p> for semantic correctness */}
        <div className='flex justify-end gap-3'>
          <Button
            variant='secondary'
            onClick={onClose}
            className='px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100 transition-colors duration-200'
          >
            {cancelText}
          </Button>
          <Button
            variant='select'
            onClick={onConfirm}
            className={`px-4 py-2 text-white rounded-md transition-colors duration-200 
              `}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
